<div class="grid">
  <div class="col-12 text-center" *ngIf="purgeConfLoading$ | async; else tablePurgeCustomer">
    <div class="col-12 spinner-container"><p-progressSpinner [style]="{width: '50px', height: '50px'}"></p-progressSpinner></div>
    <div class="col-12">{{'COMMON.LOADING_USER_LIST' | translate}}</div>
  </div>
  <ng-template #tablePurgeCustomer>
    <div class="col-12">
      <div *ngIf="conf === null || conf.length === 0">
        {{'PURGER_CONFIG.NO_CUSTOMERS'| translate}}
      </div>
      <div *ngIf="conf && conf.length > 0">
        <p-table [value]="[1]">
          <ng-template pTemplate="header">
            <tr class="header-table-purge">
              <th> {{ "PURGER_CONFIG.POSTAGE_TYPE" | translate }}</th>
              <th> {{ "PURGER_CONFIG.TITLE_PURGE" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body">
            <tr class="line-table-purge">
              <td>{{ "PURGER_CONFIG.IS_NOT_REGISTERED" | translate }}</td>
              <td>
                <p-inputNumber
                  [(ngModel)]="conf[0]"
                  [max]="3650" [min]="0"/>
                <span> jours </span>
              </td>
            </tr>
            <tr class="line-table-purge">
              <td>{{ "PURGER_CONFIG.IS_REGISTERED" | translate }}</td>
              <td>
                <p-inputNumber
                  [(ngModel)]="conf[1]"
                  [max]="3650" [min]="0"/>
                <span> jours </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="col-4">
      <button pButton type="button" [icon]="'fa fa-key'" [label]="'COMMON.SAVE' | translate"
              (click)="savePurgeConfig()" class="p-button-warning"></button>
    </div>
  </ng-template>
</div>
